import { SEO } from '@/components/seo'

export function Terms() {
  return (
    <>
      <SEO
        title="Terms of Service - AI Detector Arena"
        description="Terms of Service for AI Detector Arena. Read our terms and conditions for using our AI detector comparison platform."
        canonical="/terms"
      />

      <section className="section">
        <div className="container">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-800 mb-8">Terms of Service</h1>
            <p className="text-gray-500 mb-8">Last updated: January 1, 2026</p>

            <div className="prose prose-gray max-w-none">
              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-600 mb-4">
                By accessing or using AI Detector Arena ("Service"), you agree to be bound by these Terms of Service.
                If you do not agree to these terms, please do not use our Service.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">2. Description of Service</h2>
              <p className="text-gray-600 mb-4">
                AI Detector Arena provides tools for comparing AI image detectors, including benchmarks, rankings,
                and detection analysis. The Service is provided "as is" without warranties of any kind.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">3. User Responsibilities</h2>
              <p className="text-gray-600 mb-4">You agree to:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
                <li>Only process images you own or have permission to modify</li>
                <li>Not use the Service for illegal purposes</li>
                <li>Not use the Service to commit fraud or misrepresentation</li>
                <li>Comply with all applicable laws and regulations</li>
                <li>Not attempt to circumvent security measures or abuse the Service</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">4. Prohibited Uses</h2>
              <p className="text-gray-600 mb-4">You may not use the Service to:</p>
              <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
                <li>Remove watermarks from copyrighted content without authorization</li>
                <li>Create deepfakes or misleading content intended to deceive</li>
                <li>Process illegal content including CSAM or non-consensual imagery</li>
                <li>Violate intellectual property rights of others</li>
                <li>Engage in fraud, scams, or deceptive practices</li>
              </ul>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">5. Intellectual Property</h2>
              <p className="text-gray-600 mb-4">
                The Service, including all software, algorithms, and content, is owned by AI Detector Arena
                and protected by intellectual property laws. You retain ownership of images you upload for analysis.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">6. Privacy</h2>
              <p className="text-gray-600 mb-4">
                Your use of the Service is subject to our Privacy Policy. We do not permanently store
                images uploaded for processing. See our Privacy Policy for full details.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">7. Payment Terms</h2>
              <p className="text-gray-600 mb-4">
                Paid subscriptions are billed monthly or annually as selected. Refunds are available within
                7 days of purchase. You may cancel your subscription at any time.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">8. Limitation of Liability</h2>
              <p className="text-gray-600 mb-4">
                To the maximum extent permitted by law, AI Detector Arena shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages arising from your use of the Service.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">9. Disclaimer of Warranties</h2>
              <p className="text-gray-600 mb-4">
                The Service is provided "as is" without warranties of any kind. We do not guarantee that
                AI detection results will be 100% accurate.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">10. Indemnification</h2>
              <p className="text-gray-600 mb-4">
                You agree to indemnify and hold harmless AI Detector Arena from any claims, damages, or expenses
                arising from your use of the Service or violation of these Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">11. Termination</h2>
              <p className="text-gray-600 mb-4">
                We reserve the right to terminate or suspend your access to the Service at any time,
                with or without cause, and with or without notice.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">12. Changes to Terms</h2>
              <p className="text-gray-600 mb-4">
                We may modify these Terms at any time. Continued use of the Service after changes
                constitutes acceptance of the modified Terms.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">13. Governing Law</h2>
              <p className="text-gray-600 mb-4">
                These Terms shall be governed by the laws of the United States. Any disputes shall
                be resolved in the courts of Delaware.
              </p>

              <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">14. Contact</h2>
              <p className="text-gray-600 mb-4">
                For questions about these Terms, contact us at:{' '}
                <a href="mailto:contact@aidetectarena.com" className="text-primary-600 hover:underline">
                  contact@aidetectarena.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
